import {Component, inject, OnInit} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';
import {BreakpointObserver, Breakpoints} from '@angular/cdk/layout';
import {ErpOutboundPanelFilterService} from '../../service/erp-outbound-panel-filter.service';
import {ErpOutboundLookupService} from '../../service/erp-outbound-lookup.service';
import {ErpOutboundPanelFilterModel} from '../../models/erp-outbound-panel-filter-model';
import {
  ERP_OUTBOUND_RESPONSE_TYPE_OPTIONS,
  ERP_OUTBOUND_RESULT_OPTIONS,
} from '../../constants/erp-outbound-panel.constants';

@Component({
  selector: 'app-erp-outbound-filter-modal',
  templateUrl: './erp-outbound-filter-modal.component.html',
  styles: [`
    .filter__fields {
      display: flex;
      flex-direction: column;
      gap: 4px;
      width: 100%;
      box-sizing: border-box;
    }
    .filter__fields.two-col {
      display: grid;
      grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
      gap: 8px 20px;
    }
    mat-form-field {
      width: 100%;
      min-width: 0;
    }
  `],
  standalone: false
})
export class ErpOutboundFilterModalComponent implements OnInit {
  private readonly dialogRef = inject(MatDialogRef<ErpOutboundFilterModalComponent>);
  private readonly filterService = inject(ErpOutboundPanelFilterService);
  private readonly lookupService = inject(ErpOutboundLookupService);
  private readonly breakpointObserver = inject(BreakpointObserver);

  protected readonly form = this.filterService.form;

  protected readonly legalEntities$ = this.lookupService.getLegalEntities();
  protected readonly responseTypeOptions = ERP_OUTBOUND_RESPONSE_TYPE_OPTIONS;
  protected readonly resultOptions = ERP_OUTBOUND_RESULT_OPTIONS;

  protected isSmall = false;

  constructor() {
    this.breakpointObserver.observe([
      Breakpoints.Medium,
      Breakpoints.Small,
      Breakpoints.XSmall,
    ]).subscribe(result => {
      this.isSmall = result.matches;
    });
  }

  public ngOnInit(): void {
    this.patchForm();
  }

  private patchForm(): void {
    const filters = this.filterService.filtersValue();
    this.form.patchValue({
      InvoiceNumber: filters.InvoiceNumber,
      PNR: filters.PNR,
      ErpMessageId: filters.ErpMessageId,
      ErpOrderNumber: filters.ErpOrderNumber,
      LegalEntityId: filters.LegalEntityId,
      QueueName: filters.QueueName,
      ResponseType: filters.ResponseType,
      Result: filters.Result,
      CreatedDateFrom: filters.CreatedDateFrom,
      CreatedDateTo: filters.CreatedDateTo,
      AdxInvoiceId: filters.AdxInvoiceId,
      HasSalesOrderNumber: filters.HasSalesOrderNumber,
      HasAdxInvoiceId: filters.HasAdxInvoiceId,
    });
  }

  protected apply(): void {
    const raw = this.form.getRawValue();
    const filters: ErpOutboundPanelFilterModel = {
      InvoiceNumber: raw.InvoiceNumber,
      PNR: raw.PNR,
      ErpMessageId: raw.ErpMessageId,
      ErpOrderNumber: raw.ErpOrderNumber,
      LegalEntityId: raw.LegalEntityId,
      QueueName: raw.QueueName,
      ResponseType: raw.ResponseType,
      Result: raw.Result,
      CreatedDateFrom: raw.CreatedDateFrom,
      CreatedDateTo: raw.CreatedDateTo,
      AdxInvoiceId: raw.AdxInvoiceId,
      HasSalesOrderNumber: raw.HasSalesOrderNumber,
      HasAdxInvoiceId: raw.HasAdxInvoiceId,
      ReloadGrid: true,
    };

    this.filterService.setFilters(filters);
    this.close();
  }

  protected reset(): void {
    this.form.reset();
    this.filterService.setFilters({
      ...this.filterService.buildDefaultFilters(),
      ReloadGrid: true,
    });
    this.close();
  }

  protected close(): void {
    this.dialogRef.close();
  }

  clearErpSalesOrderNumberFilter() {
    this.form.patchValue({
      HasSalesOrderNumber: null
    });
  }

  clearErpAdxInvoiceIdFilter() {
    this.form.patchValue({
      HasAdxInvoiceId: null
    });
  }
}
